import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=0e210682&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=ts"
export * from "./QuizPage.vue?vue&type=script&lang=ts"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=0e210682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e210682",
  null
  
)

export default component.exports